import { IBenefit, IBenefitPlan, IPaymentSystem, ISubscribeGroup } from "../entryes/panel/Courses/GroupSettings/types";
import http from "./client";

async function getGroupPlans(groupId: string | number, paymentSystem?: IPaymentSystem['code']) {
  const response = await http.get<ISubscribeGroup>('/api/benefitplan/group', {
    params: {
      group_id: groupId,
      paymentSystem
    }
  });
  return response.data;
}

async function getCoursePlans(groupId: string | number, courseId: string | number, paymentSystem?: IPaymentSystem['code'], groupType?: string) {
  const response = await http.get<Array<IBenefitPlan>>('/api/benefitplan/course', {
    params: {
      course_id: courseId,
      group_id: groupId,
      type: groupType,
      paymentSystem
    }
  });
  return response.data
}


async function copyPlan(id: number): Promise<IBenefitPlan> {
  const res = await http.post(
    `/api/benefitplan/copy`, {plan_id: id}, {
      params: {
        id,
      }
    });

    return res.data;
}


async function deletePlan(courseId: string| number, groupId: string | number, planId: string | number) {
  const res = await http.post('/api/benefitplan/delete', {plan_id: planId}, {
    params: {
      group_id: groupId,
      courseId: courseId,
    }
  });
  return res.data;
}


async function deleteBenefit(planId: string | number) {
  const res = await http.post('/api/benefit/delete', {benefit_id: planId});
  return res.data;
}


async function createBenefitPlan(data: IBenefitPlan, groupId: string | number, courseId?: string | number): Promise<IBenefitPlan> {
  const res = await http.post(
    `/api/benefitplan/add`,
    {
      ...data,
      group_id: groupId,
      course_id: courseId,
    });

  return res.data;
}

async function createBenefit(benefitPlanId: number, data: IBenefit, groupId: string | number, courseId?: string | number):Promise<IBenefit> {
  const res = await http.post(`/api/benefit/add`, {
    ...data,
    planId: benefitPlanId,
    groupId,
    courseId,
  }, {
    params: {
      course_id: courseId,
      group_id: groupId,
    }
  })

  return res.data;
}

async function updateBenefit(data: IBenefit, groupId: string | number, courseId?: string | number): Promise<IBenefit> {
  const res = await http.post(`/api/benefit/benefit?benefit_id=${data.id}`, {...data, status: 'active'}, {
    params: {
      benefit_id: data.id,
      course_id: courseId,
      group_id: groupId,
    }
  });

  return res.data;
}

async function getBenefit(id: number | string): Promise<IBenefit> {
  const res = await http.get('/api/benefit/get', {
    params: {id}
  });
  return res.data;
}

async function getBenefitPlan(groupId: string | number, courseId: string | number, id: number | string): Promise<IBenefitPlan> {
  const res = await http.get('/api/benefitplan/get', {
    params: {id, course_id: courseId, group_id: groupId}
  });
  return res.data;
}

async function updateBenefits(data: Partial<ISubscribeGroup>, groupId: string | number, courseId: string | number): Promise<ISubscribeGroup> {
  const res = await http.post(
    `/api/benefitplan/group`,
    {
      ...data,
    },
    {
      params: {
        group_id: groupId,
        course_id: courseId,
      }
    }
  );

  return res.data;
}


const plans = {getCoursePlans, getGroupPlans, copyPlan, deletePlan, deleteBenefit, getBenefit, createBenefit, createBenefitPlan, updateBenefits, getBenefitPlan, updateBenefit };
export default plans;